// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewSMSComm_root__1lrdU","body":"PreviewSMSComm_body__3pzap"};